// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1spMA","box":"WorkspacesBox_box__3vnvP","node":"WorkspacesBox_node__2K4aE"};